import { useSelector } from "react-redux";

import { Box, makeStyles, Typography } from "@material-ui/core";

import { LABELS } from "../constants";
import IconCard from "../../iconCard";
import { SUBMETERS } from "../../../../../services/constants";
import yesIcon from "../../../../../assets/images/icons/workspace/yes.svg";
import noIcon from "../../../../../assets/images/icons/workspace/no.svg";
import yesIconSelected from "../../../../../assets/images/icons/workspace/yes-selected.svg";
import noIconSelected from "../../../../../assets/images/icons/workspace/no-selected.svg";
import onePersonIcon from "../../../../../assets/images/icons/workspace/one-person.svg";
import onePersonIconSelected from "../../../../../assets/images/icons/workspace/one-person-selected.svg";
import percentIcon from "../../../../../assets/images/icons/workspace/percent.svg";
import percentIconSelected from "../../../../../assets/images/icons/workspace/percent-selected.svg";
import twoPersonIcon from "../../../../../assets/images/icons/workspace/two-person.svg";
import twoPersonIconSelected from "../../../../../assets/images/icons/workspace/two-person-selected.svg";
import roomIcon from "../../../../../assets/images/icons/workspace/room.svg";
import roomIconSelected from "../../../../../assets/images/icons/workspace/room-selected.svg";
import questionMarkIcon from "../../../../../assets/images/icons/workspace/questionMark.svg";
import questionMarkIconSelected from "../../../../../assets/images/icons/workspace/questionMark-selected.svg";
import ByArea from "../../../../../components/parts/byArea";

const yesNoIcon = [
  {
    id: true,
    icon: yesIcon,
    iconSelected: yesIconSelected,
    label: "Yes",
  },
  {
    id: false,
    icon: noIcon,
    iconSelected: noIconSelected,
    label: "No",
  },
];

const rentalCostIcon = [
  {
    id: "FIX_PRICE",
    icon: onePersonIcon,
    iconSelected: onePersonIconSelected,
    width: 50,
    height: 67,
  },
  {
    id: "PERCENT_SPACE",
    icon: percentIcon,
    iconSelected: percentIconSelected,
    width: 38,
    height: 37,
  },
  {
    id: "BY_AREA",
    component: ByArea,
  },
  {
    id: "NUMBER_TENANTS",
    icon: twoPersonIcon,
    iconSelected: twoPersonIconSelected,
    width: 41,
    height: 67,
  },
  {
    id: "NUMBER_ROOMS",
    icon: roomIcon,
    iconSelected: roomIconSelected,
    width: 41,
    height: 67,
  },
  {
    id: "UNKNOWN",
    icon: questionMarkIcon,
    iconSelected: questionMarkIconSelected,
    width: 38,
    height: 37,
  },
];

const electricityByTenants = [
  {
    id: "FIX_PRICE",
    icon: onePersonIcon,
    iconSelected: onePersonIconSelected,
    width: 50,
    height: 67,
  },
  {
    id: "BY_AREA",
    component: ByArea,
  },
  {
    id: "PERCENT_SPACE",
    icon: percentIcon,
    iconSelected: percentIconSelected,
    width: 38,
    height: 37,
  },
];

const useStyles = makeStyles(() => ({
  heading: {
    fontSize: 30,
    fontWeight: 700,
  },
  iconDiv: {
    display: "flex",
  },
  subHeading: {
    fontSize: 18,
    marginTop: 16,
    marginBottom: 16,
  },
  textStyle: {
    fontSize: 14,
    marginTop: 14,
    marginBottom: 14,
  },
  topDiv: {
    marginTop: 50,
  },
  bottomDiv: {
    marginTop: 50,
    paddingBottom: 20,
  },
  centerStyle: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    marginTop: 36,
  },
}));

export const TenantsElectricityBills = ({ meterData, data, onDataChange }) => {
  const classes = useStyles();
  const { user } = useSelector((state) => state.auth);

  const isSubMeters = meterData?.type === SUBMETERS;
  const yesNoKey = isSubMeters ? "back_to_back" : "separated_payment";
  const isElectricityOption = yesNoKey === "separated_payment" && !data.separated_payment;
  const secondKey = isElectricityOption ? "electricity_cost" : "payment_model";

  const onChange = (key, value) => {
    const d = {
      ...data,
      [key]: value,
    };
    if (key === "separated_payment") {
      if (value) {
        d["electricity_cost"] = null;
      } else {
        d["payment_model"] = null;
      }
    }
    onDataChange("meter_type", "electricity_bill", d);
  };

  return (
    <Box>
      <Typography className={classes.heading}>Tenants and electricity bills</Typography>
      <Box className={classes.topDiv}>
        <Typography className={classes.subHeading}>
          {isSubMeters
            ? "Do tenants pay for electricity on a full back-to-back basis?"
            : "Is the payment for electricity separated from payment for rental?"}
        </Typography>
        <Box className={classes.iconDiv}>
          {yesNoIcon.map((icon, i) => {
            return (
              <IconCard
                key={i}
                id={icon.id}
                centerStyle={classes.centerStyle}
                selected={data[yesNoKey] === icon.id}
                src={data[yesNoKey] === icon.id ? icon.iconSelected : icon.icon}
                onClick={(id) => onChange(yesNoKey, id)}
                Component={icon.component}
              />
            );
          })}
        </Box>
      </Box>
      <Box className={classes.bottomDiv}>
        <Typography className={classes.subHeading}>
          {isElectricityOption
            ? "How is the costs of electricity calculated in the rental costs?"
            : "What is the payment model for electricity by tenants?"}
        </Typography>

        <Box className={classes.iconDiv}>
          {(isElectricityOption ? rentalCostIcon : electricityByTenants).map((icon, i) => {
            return (
              <IconCard
                key={i}
                id={icon.id}
                height={icon.height}
                width={icon.width}
                centerStyle={classes.centerStyle}
                selected={data[secondKey] === icon.id}
                src={data[secondKey] === icon.id ? icon.iconSelected : icon.icon}
                onClick={(id) => onChange(secondKey, id)}
                Component={icon.component}
              />
            );
          })}
        </Box>

        <Typography className={classes.textStyle}>
          {LABELS[data[secondKey]]?.replace("sqft", user?.unit_system)}
        </Typography>
      </Box>
    </Box>
  );
};
